//
//
//
//
//
//

import { mapState } from 'vuex';

function handleSeoRedirect(targetUrl, route, redirect) {
  if (!targetUrl) {
    return;
  }

  const url = new URL(targetUrl);
  if (url.pathname !== route.path) {
    // Replace path and keep the existing query string.
    const redirectFullPath = route.fullPath.replace(route.path, url.pathname);
    redirect(301, redirectFullPath);
  }
}

export default {
  name: 'TemplatesProductPage',
  layout: 'empty',
  components: {
    ProductPage: () => import('@/components/ProductPage.vue'),
  },
  async asyncData({ params, store, error }) {
    // Slug shape: "{numericId}-{kebab-title}" e.g. 26546553-simple-task-manager
    const match = params.slug && params.slug.match(/^(\d+)-(.+)$/);
    if (!match) {
      error({ statusCode: 404 });
      return;
    }
    const [, id] = match;
    if (id) {
      store.commit('product/setProductId', id);
    }
    return {};
  },
  computed: {
    ...mapState({
      productId: state => state.product.id,
    }),
  },
  async fetch({
    store, route, error, redirect,
  }) {
    const productId = store.state.product.id;
    if (productId) {
      try {
        await store.dispatch('product/fetchProductSchema');
      } catch (err) {
        console.error(err);
      }
      try {
        await store.dispatch('product/getElementDetails', { id: productId });

        if (!store.state.product.current) {
          error({ statusCode: 404 });
          return;
        }

        handleSeoRedirect(store.state.product.current.url, route, redirect);
      } catch (err) {
        error({ statusCode: err?.response?.status || 500 });
      }
    }
  },
};
